/**
 * Auto-lift toast animation for two-slice toaster ver2 banner 2.
 */
if (!customElements.get('two-toaster-ver2-banner2')) {
  class TwoToasterVer2Banner2 extends HTMLElement {
    /** @type {HTMLElement | null} */
    _devices = null;
    /** @type {NodeListOf<HTMLImageElement> | null} */
    _toasts = null;
    /** @type {number} */
    _devicesBoxOffsetY = 0;

    connectedCallback() {
      this._devices = this.querySelector('.product-devices');
      this._toasts = this.querySelectorAll('img.toast');
      if (!this._devices || !this._toasts.length) return;

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._updateOffset();

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    _updateOffset() {
      if (!this._devices) return;
      const rect = this._devices.getBoundingClientRect();
      this._devicesBoxOffsetY = window.scrollY + rect.top + this._devices.offsetWidth * 0.25;
    }

    _onResize() {
      this._updateOffset();
      this._onScroll();
    }

    _onScroll() {
      if (!this._toasts) return;

      const viewportHeight = window.innerHeight;
      const scrollViewportY = window.scrollY + viewportHeight;
      if (scrollViewportY <= this._devicesBoxOffsetY - 70) return;

      let toastMovePercent = 100 - ((scrollViewportY - this._devicesBoxOffsetY) / (viewportHeight * 0.4)) * 100;
      if (toastMovePercent > 200) toastMovePercent = 200;
      if (toastMovePercent < 5) toastMovePercent = 5;

      const transform = `translateY(${toastMovePercent}%)`;
      this._toasts.forEach((img) => {
        img.style.transform = transform;
      });
    }
  }

  customElements.define('two-toaster-ver2-banner2', TwoToasterVer2Banner2);
}
